<div [ngClass]="modalShow === true ? 'modal show' : 'modal hide'" id="modalParamet">
    <article>
        <img src="../../../assets/images/icons/deactivate_circle_icon.png" alt="imagen de alerta de modal">
        <h1>{{messageModal.title}}</h1>
        <p>{{messageModal.text}}</p>
        <button *ngIf="!messageModal.functBtnPrimary" class="button fondoBtn">{{messageModal.textBtn}}</button>
        <button *ngIf="messageModal.functBtnPrimary" class="button fondoBtn" (click)="messageModal.functBtnPrimary()">{{messageModal.textBtn}}</button>
        
        <div class="containBtnOut" *ngIf="messageModal.isBtnRecovery">
            <a class="styleBtnOutline" (click)="messageModal.functBtnSecond()">Olvidé mi contraseña</a>
        </div>
        <div class="containBtnOut" *ngIf="messageModal.isBtnTryAgain">
            <a class="styleBtnOutline" (click)="messageModal.functBtnSecond()">Intentar en otro momento</a>
        </div>
    </article>
</div>
